import { Alert, Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { useApp } from '../context/AppContext';

export function BillingResultPage({ status = 'success' }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refreshAppState } = useApp();
  const sessionId = params.get('session_id') || '';

  useEffect(() => {
    if (status !== 'success') return undefined;

    // Stripe webhooks can arrive a moment after Checkout redirects back.
    // Refresh a few times so the user does not have to manually reload.
    const timers = [700, 2200, 5000].map((delay) => setTimeout(() => {
      refreshAppState().catch(() => null);
    }, delay));

    return () => timers.forEach(clearTimeout);
  }, [status, refreshAppState]);

  const success = status === 'success';

  return (
    <Box className="app-grid" minHeight="100vh">
      <AppHeader />
      <Container maxWidth="sm" sx={{ py: { xs: 5, md: 8 } }}>
        <Card>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            {success && <CheckCircleRoundedIcon color="success" sx={{ fontSize: 54 }} />}

            <Typography variant="h1" sx={{ fontSize: { xs: 34, md: 44 }, mt: 2 }}>
              {success ? 'You’re upgraded.' : 'Checkout cancelled.'}
            </Typography>

            <Typography color="text.secondary" sx={{ mt: 1.2 }}>
              {success
                ? 'Stripe confirmed your checkout. Your updated plan should appear in NudgeForMe shortly.'
                : 'No payment was completed. You can upgrade again anytime.'}
            </Typography>

            {success && sessionId && (
              <Alert severity="info" sx={{ mt: 2, textAlign: 'left' }}>
                Refreshing your plan now. Stripe session: {sessionId.slice(0, 18)}…
              </Alert>
            )}

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2} justifyContent="center" sx={{ mt: 3 }}>
              <Button variant="contained" onClick={() => navigate('/home')}>Go to dashboard</Button>
              <Button variant="outlined" onClick={() => navigate('/settings')}>Open settings</Button>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
